import { Box } from '@ublend-npm/aulaui-core';
import React from 'react';
import { ResponsiveAssignment } from '@core/assignments/types';
import AssignmentCard from '../AssignmentCard/AssignmentCard';
import { createStyles } from './AssignmentList.styles';
import { useSelector } from 'react-redux';
import { getLtiProviders } from '@core/selectors/lti';
import { AulaState } from '@core/types/state';

type Props = {
  assignments: ResponsiveAssignment[];
  spaceId: string;
  isEducator?: boolean;
  highlightedAssignmentId?: string | null;
  onMaterialClick?: (
    materialId: string,
    materialTitle?: string,
    assignmentId?: string
  ) => void;
  onTurnitinClick?: (assignment: ResponsiveAssignment) => void;
};

const AssignmentList = ({
  assignments,
  spaceId,
  isEducator,
  highlightedAssignmentId,
  onMaterialClick,
  onTurnitinClick,
}: Props) => {
  const styles = createStyles();
  const state = useSelector((state) => state);
  const providers = getLtiProviders(state as AulaState);
  const isHighlighted = (assignment: ResponsiveAssignment) =>
    assignment.id === highlightedAssignmentId ||
    assignment.objectId === highlightedAssignmentId;

  return (
    <Box sx={styles.listWrapper}>
      {assignments?.map((assignment) => (
        <AssignmentCard
          assignment={assignment}
          key={assignment.id || assignment.objectId}
          spaceId={spaceId}
          providers={providers}
          isEducator={isEducator}
          highlighted={isHighlighted(assignment)}
          onMaterialClick={onMaterialClick}
          onTurnitinClick={onTurnitinClick}
        />
      ))}
    </Box>
  );
};

export default AssignmentList;
